/* eslint-disable */

import axios from "axios";

const httpClient = axios.create({
});

httpClient.interceptors.response.use(
  (config) => {
    config.headers['Content-Type'] = 'application/json';
        return config;
    },
  (response) => response,
  (error) => Promise.reject(error)
);

export default httpClient;
